import React, { Component, Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import './index.scss';
import Main from "./components/main";
import {Provider} from "react-redux";
import configureStore from "./config/configureStore";
import {HeadProvider} from "react-head";
import {HTML5Backend} from "react-dnd-html5-backend";
import { GoogleOAuthProvider } from '@react-oauth/google';
import {DndProvider} from "react-dnd";
import { GOOGLECLIENTID } from './helper/host';
import { initSentry } from './utils/sentry';
import { installGlobalErrorHandler } from './utils/globalErrorHandler';
import ErrorBoundary from './components/common/ErrorBoundary';
import FullPageLoader from './components/common/FullPageLoader';

initSentry();
installGlobalErrorHandler();

const store = configureStore();
class Root extends Component {
    render() {
        return (
            <GoogleOAuthProvider clientId={GOOGLECLIENTID}>
                <HeadProvider>
                    <Provider store={store}>
                        <DndProvider backend={HTML5Backend}>
                            <ErrorBoundary name="root">
                                <Suspense fallback={<FullPageLoader />}>
                                    <Main />
                                </Suspense>
                            </ErrorBoundary>
                        </DndProvider>
                    </Provider>
                </HeadProvider>
            </GoogleOAuthProvider>
        )
    }
}

// Outer ErrorBoundary also wraps Sentry.ErrorBoundary so we still get
// Sentry's error reporting, but our custom UI takes precedence on render.
// This way: any uncaught error in <Root /> shows our branded error
// screen with a "Coba lagi" button (and Sentry is still notified).
ReactDOM.render(
    <Sentry.ErrorBoundary fallback={null} showDialog={false}>
        <ErrorBoundary name="outer">
            <Root />
        </ErrorBoundary>
    </Sentry.ErrorBoundary>,
    document.getElementById('root')
);


